import React from 'react';

import { MailOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { message, Button } from 'antd';

import WhatsAppLink from 'v2/components/Shared/WhatsAppLink';
import type { AccountManager } from 'v2/interfaces/user';
import analyticsService from 'v2/services/analytics';

interface IProps {
  data: AccountManager;
}

function ManagerInfo({ data }: IProps) {
  const [messageApi, contextHolder] = message.useMessage();
  const photoSrc = data.photo ? data.photo : '/img/avatar-default.svg';

  async function handleCopyEmail(): Promise<void> {
    try {
      await navigator.clipboard.writeText(data.email);
      messageApi.success('E-mail copiado.');
      analyticsService.sendEvent('Email Button Clicked', 'Dashboard - Account Manager');
    } catch (err) {
      messageApi.error('Falha ao copiar E-mail!');
    }
  }

  function handleRedirectWhatsApp() {
    analyticsService.sendEvent('WhatsApp Button Clicked', 'Dashboard - Account Manager');
  }

  return (
    <>
      {contextHolder}
      <div className='mb-2 flex flex-col justify-center gap-4 rounded border border-gray-100 bg-white p-4 shadow'>
        <div className='flex items-center gap-2'>
          <img src={photoSrc} alt='icone gerente de conta' className='h-10 w-10 rounded-full' />
          <div className='flex flex-col'>
            <span className='m-0 text-base font-bold'>{data.name}</span>
            <span className='m-0 text-sm font-normal text-gray-500'>Consultor de sucesso</span>
          </div>
        </div>
        <div className='flex gap-4'>
          <Button id='btn-copy-email' className='group m-0 flex h-8 flex-1 gap-2 p-0' onClick={handleCopyEmail}>
            <MailOutlined className='mr-0.5' size={17} alt='Icone E-mail' />
            <span className='m-0 text-sm font-normal'>E-mail</span>
          </Button>
          {data.phone ? (
            <WhatsAppLink phone={data.phone} stylesProps='w-1/2'>
              <Button
                id='btn-redirect-whatsapp'
                className='m-0 flex h-8 flex-1 gap-2 p-0'
                onClick={handleRedirectWhatsApp}
                style={{ width: '100%' }}
              >
                <WhatsAppOutlined className='mr-0.5' size={17} alt='Icone E-mail' />
                <span className='m-0 text-sm font-normal'>WhatsApp</span>
              </Button>
            </WhatsAppLink>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default ManagerInfo;
